// extracted by mini-css-extract-plugin
module.exports = {"content":"_93444fe79c--content--ruefw","title":"_93444fe79c--title--i99HN","description":"_93444fe79c--description--Kz0Ir"};